module.exports = __webpack_public_path__ + "static/media/kalkat.598df551.png";